<template>
  <div ref="container">
    <a-modal :title="title" :width="500" :visible="visible" :maskStyle="{ 'top': '93px', 'left': '154px' }" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height:60%;">
      <a-form :form="form">
        <a-row :gutter="24">
          
          <a-col :lg="24" :md="24" :sm="24" style="margin-bottom: 20px" v-if="printType != 'Singleprinting'">
            <a-radio-group v-model="isAllSelect" @change="onChange">
              <a-radio :value="1">全部打印</a-radio>
              <a-radio :value="0">部分打印</a-radio>
             <!-- <a-radio :value="2">打印未打印部分</a-radio> -->
            </a-radio-group>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24" v-show="!isAllSelect">
            <a-form-item label="起始序号：" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin:0">
              <a-input placeholder="请输入起始序号" v-model="startLocation"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24"  v-show="!isAllSelect">
            <a-form-item label="结束序号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin:0">
              <a-input placeholder="请输入结束序号" v-model="endLocation"></a-input>

            </a-form-item>
          </a-col>
          <a-col :lg="24" :md="24" :sm="24">
            <a-form-item label="打印份数" :labelCol="{span: 4}" :wrapperCol="{span: 20}" style="margin-bottom: 0;">
              <a-input-number placeholder="1" v-model="copies" :min="1"></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <a-form-item label="请选择模版名称">
              <a-select placeholder="请选择模版名称" showSearch optionFilterProp="children" v-decorator.trim="['templateid', validatorRules.templateid]">
                <a-select-option v-for="(depot, index) in templateList" :value="depot.uuid" :key="index">
                  {{ depot.templateName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { printApi, printgetAll, piInfoApi } from '@/api/api'
import TaskRunner from 'concurrent-tasks'
import {startPrint } from '@/views/UDIadmin/modules/allPrint'
export default {
  name: 'VendorModal',
  data() {
    return {
      printType:'',
      item:{},
      total:1,
      title: '选择打印模版',
      visible: false,
      model: {},
      dataSource: [],
      labelCol: {
        span: 10,
      },
      wrapperCol: {
        span: 13,
        offset: 1,
      },
      loading: false,
      productInfo: {},
      templateList: [],
      templateid: '',
      startLocation: '',
      endLocation: '',
      copies: 1,
      isAllSelect: true,
      isShow: false,
      form: this.$form.createForm(this),
      validatorRules: {
        templateid: {
          rules: [
            {
              required: true,
              message: '请选择模版名称!',
            },
          ],
        },
        startLocation: {
          rules: [
            {
              required: true,
              message: '请选择输入起始序号!',
            },
          ],
        },
        endLocation: {
          rules: [
            {
              required: true,
              message: '请选择输入结束序号!',
            },
          ],
        }
      },
      productList: [],
    }
  },
  created() {},
  methods: {
    //切换打印方法
    onChange(e) {
      if(e.target.value == true){
        console.log(this.isAllSelect)
        this.isShow = false
      } else {
        this.isShow = true
      }
    },
    // 直接传入列表
    async add(e) {
      this.visible = true
      this.form.resetFields()
      this.getlist()
      if (e) {
        // this.productList = e
      }
    },
    // 通过id获取列表
    async addStr(e, type) {
      this.printType = type
      this.visible = true
      this.form.resetFields()
      this.productList = []
      this.getlist()
      this.item = e
      if (e && type === 'Batchprint') {
        // 获取列表
        const res = await piInfoApi({ id: e.id, limit: 1,startNumber:-1,endNumber:-1 })
        if (res.errno == 200 && res.errmsg == '成功') {
          this.loading = false
          this.productList = res.data.list
          this.total = res.data.total
          console.log(this.productList, 'this.productList')
        } else {
          this.$message.error(res.data || res.errmsg)
        }
        // this.productList = e
      } else if (e && type === 'Singleprinting') {
        console.log(this.productList, '添加前')
        console.log(e, 'e')
        this.productList.push(e)
        this.total = 1
        console.log(this.productList, '添加后')
      }
    },
    async getlist() {
      const res = await printgetAll()
      if (res.code == 200) {
        this.templateList = res.data
      } else {
        this.$message.error(res.data || res.msg)
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      this.form.validateFields(async (err, values) => {
        if (!err) {
          console.log(this.templateList,'=============this.templateList===========')

          const productDi = this.templateList.find((x) => x.uuid === values.templateid)
          const printCopies =  this.copies

          if(this.printType == 'Singleprinting'){
            //如果是单独一条打印就直接打印了
            startPrint(this.productList, productDi, this.copies,()=>{})
            this.handleCancel()
            return false
          }

          //以下是批量打印队列
          const runner = new TaskRunner()
          // 同时执行数量
          runner.setConcurrency(1)
          const task = []
          let page = 0
          const limit = 500
          const pageNumber = Math.ceil(this.total / limit)
          let beginNumber=0
          let endNumber=this.total
          if (this.isAllSelect == false && this.startLocation && this.endLocation) {
            if(!/^[1-9]\d*$/.test(this.startLocation) || !/^[1-9]\d*$/.test(this.endLocation)){
              this.$message.warning('请输入正整数')
              return false
            }
            if(!(parseInt(this.startLocation)<=parseInt(this.endLocation))){
              this.$message.warning('开始不能小于结束')
              return false
            }
            beginNumber = parseInt(this.startLocation)-1
            endNumber = parseInt(this.endLocation)
          }else{
            // if(!this.isAllSelect && (!this.startLocation || !this.endLocation)){
            //   this.$message.warning('请输入正整数')
            //   return false
            // }
          }
          console.log(this.total,limit)
          for (let i = 1;i<=pageNumber;i++){
            task.push(async doneApi=>{
              const res = await piInfoApi({ id: this.item.id,page:i, limit,beginNumber,endNumber })
              if (res.errno == 200 && res.errmsg == '成功' ) {
                if(res.data.list.length == 0){
                  doneApi()
                }else{
                  this.productList = res.data.list
                  startPrint(this.productList, productDi, this.copies,doneApi,runner,{pageNumber:i,limit})
                }
              } else {
                this.$message.error(res.data || res.errmsg)
              }
            })
          }
          runner.addMultiple(task)
          this.handleCancel()
        }
      })
    },

    handleCancel() {
      this.close()
    },
  },
}
</script>
<style scoped></style>